import {
  SET_USER_MESSAGES_LIST,
  SET_USER_MESSAGES_LIST_PAGE,
  SET_USER_MESSAGES_LIST_PAGE_SIZE,
  SET_USER_MESSAGES_LIST_PAGE_SIZE_TOTAL,
  SET_USER_MESSAGES_LIST_QUERY,
  SET_USER_MESSAGE_STATUS,
} from './mutation-types'
import api from '@/api'
import _ from 'lodash'

const initQuery = () => {
  return {
    pageNum: '',
    pageSize: '',
  }
}

const state = {
  userMessageList: {
    list: [],
    listCurrentPage: 1,
    listPageSize: 50,
    listPageTotal: 0,
    query: initQuery(),
  },
  status: 0,
}

const mutations = {
  [SET_USER_MESSAGES_LIST] (state, payload) {
    state.userMessageList.list = payload
  },
  [SET_USER_MESSAGES_LIST_PAGE] (state, payload) {
    state.userMessageList.listCurrentPage = payload
  },
  [SET_USER_MESSAGES_LIST_PAGE_SIZE] (state, payload) {
    state.userMessageList.listPageSize = payload
  },
  [SET_USER_MESSAGES_LIST_PAGE_SIZE_TOTAL] (state, payload) {
    state.userMessageList.listPageTotal = payload
  },
  [SET_USER_MESSAGES_LIST_QUERY] (state, payload) {
    state.userMessageList.query = {
      ...state.userMessageList.query,
      ...payload,
    }
  },
  [SET_USER_MESSAGE_STATUS] (state, payload) {
    state.status = payload
  },
}

const actions = {
  async setUserMessagesList ({commit, state}, payload) {
    try {
      let query = {}
      _.forIn(state.userMessageList.query, (v, k) => {
        if (v !== '') query[k] = v
      })
      let params = {
        ...query,
        pageNum: state.userMessageList.listCurrentPage,
        pageSize: state.userMessageList.listPageSize,
      }
      const {data: {items, total}} = await api.userApi.queryMessagesByPage(params)
      commit(SET_USER_MESSAGES_LIST, items)
      commit(SET_USER_MESSAGES_LIST_PAGE_SIZE_TOTAL, total)
    } catch (error) {
      commit(SET_USER_MESSAGES_LIST, [])
      commit(SET_USER_MESSAGES_LIST_PAGE_SIZE_TOTAL, 0)
    }
  },
  initUserMessagesList ({commit, dispatch}) {
    let query = initQuery()
    commit(SET_USER_MESSAGES_LIST_QUERY, query)
    dispatch('changeUserMessagesListPage', {currentPage: 1})
  },
  async changeUserMessagesListPage ({commit, dispatch}, {currentPage}) {
    commit(SET_USER_MESSAGES_LIST_PAGE, currentPage)
    await dispatch('setUserMessagesList')
  },
  changePageSize ({commit, dispatch}, payload) {
    commit(SET_USER_MESSAGES_LIST_PAGE_SIZE, payload.listPageSize)
    dispatch('changeUserMessagesListPage', {currentPage: 1})
  },
  changeQuery ({commit}, payload) {
    commit(SET_USER_MESSAGES_LIST_QUERY, payload)
  },
  async changeStatus ({commit}, payload) {
    const {code} = await api.userApi.changeState(payload)
    if (code === 200) {
      commit(SET_USER_MESSAGE_STATUS, payload.status)
    }
  },
  async addRemark ({dispatch}, payload) {
    const {code, message} = await api.userApi.updateRemark(payload)
    if (code === 200) {
      dispatch('setUserMessagesList')
    }
    return {code, message}
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
